import React from "react";
import Paral1 from "./components/Paral1";
import Paral2 from "./components/Paral2";
import Paral3 from "./components/Paral3";
import Form from "./components/Form";
import { motion } from "framer-motion";

import ToTop from "./components/Subassets/ToTop";
import { Helmet, HelmetData } from "react-helmet-async";

const helmetData = new HelmetData({});
const LayoutMain = () => {
  return (
    <>
      <Helmet helmetData={helmetData}>
        <meta
          name="description"
          content="My inforamtion | Portfolio | basic inforamtion about me like working as frontend developer and skills to know about me"
        />
        <title>DevProfile | Home</title>
      </Helmet>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, delay: 1 }}
        transition={{
          ease: "easeInOut",
          duration: 0.7,
          delay: 0.15,
        }}
      >
        <Paral1 />
        <Paral2 />
        <Paral3 />
        <ToTop name="Home" />
        <Form />
      </motion.div>
    </>
  );
};

export default LayoutMain;
